/**
 * Menu strip on rental, rental information and repair pages (the rental-nav markup).
 * When the links are wider than the page, arrow buttons appear on both sides to scroll them.
 * The current page's link is scrolled into view on load. Without this file the strip still scrolls by swipe or trackpad.
 */
(function () {
  const ARROW_LEFT = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M15 5l-7 7 7 7"/></svg>';
  const ARROW_RIGHT = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 5l7 7-7 7"/></svg>';

  function init(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const list = nav.querySelector('.rental-nav__links');
    if (!list) return;

    const scroller = document.createElement('div');
    scroller.className = 'rental-nav__scroller';
    list.parentNode.insertBefore(scroller, list);

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'rental-nav__arrow rental-nav__arrow--prev';
    prev.setAttribute('aria-label', nav.dataset.labelPrev || 'Scroll left');
    prev.innerHTML = ARROW_LEFT;

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'rental-nav__arrow rental-nav__arrow--next';
    next.setAttribute('aria-label', nav.dataset.labelNext || 'Scroll right');
    next.innerHTML = ARROW_RIGHT;

    scroller.append(prev, list, next);

    function update() {
      const max = list.scrollWidth - list.clientWidth;
      const overflow = max > 2;
      scroller.classList.toggle('has-overflow', overflow);
      prev.disabled = !overflow || list.scrollLeft <= 2;
      next.disabled = !overflow || list.scrollLeft >= max - 2;
      scroller.classList.toggle('at-start', prev.disabled);
      scroller.classList.toggle('at-end', next.disabled);
    }

    function step(dir) {
      list.scrollBy({ left: dir * Math.max(list.clientWidth * 0.7, 160), behavior: 'smooth' });
    }
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);

    const current = list.querySelector('[aria-current="page"]');
    if (current) {
      const li = current.closest('li');
      const target = li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2;
      list.scrollLeft = Math.max(0, target);
    }
    update();
  }

  document.querySelectorAll('[data-rental-nav]').forEach(init);
})();
